// extracted by mini-css-extract-plugin
module.exports = {"Hero":"_26qKW","TextContainer":"_2uJwV","ImageContainer":"AJM7Z","Text":"Mgxwf","Image":"_1JnJz"};